import { ref } from 'vue';
import type { Airflow } from '@aviata/platform-types';

export const useExchangeReturnPolicy = (
  fetchFareRules: (offerId: string) => Promise<Airflow.FareRules.Entity>,
  offerId: string,
) => {
  const isLoading = ref(false);
  const fareRules = ref<Airflow.FareRules.Segment[]>();

  function getFareRules() {
    if (!fareRules.value) {
      isLoading.value = true;
      fetchFareRules(offerId)
        .then(res => (fareRules.value = res.items))
        .finally(() => (isLoading.value = false));
    }
  }

  return {
    isLoading,
    fareRules,
    getFareRules,
  };
};
